import { OpenSansText } from "@Components/CustomText/OpenSansText"
import { Spacer } from "@Components/Space"
import { baseColors } from "@Constants/baseStyles"
import { truncateString } from "@Utils/utils"
import React, { useState } from "react"
import { Dimensions, StyleSheet, TouchableOpacity, View } from "react-native"

const { width, height } = Dimensions.get("screen")

export const QuestionCard = (props) => {
    return (
        <TouchableOpacity
            onPress={() => {
                !props?.disabled && props.onPress && props.onPress()
            }}
            activeOpacity={0.7}
        >
            <View
                style={{
                    backgroundColor: props.active ? baseColors.green.dark : baseColors.green.light,
                    ...styles.back
                }}
            >
                {props.icon}

                <Spacer height={10} />

                <OpenSansText
                    fontWeight={"bold"}
                    fontSize={12}
                    color={props.active ? baseColors.white : baseColors.green.dark}
                >
                    {props.title}
                </OpenSansText>

                {props.active && (
                    <View style={{ paddingLeft: 10, paddingRight: 10, paddingTop: 8 }}>
                        <OpenSansText
                            numberOfLines={2}
                            fontSize={12}
                            color={props.active ? baseColors.white : baseColors.green.dark}
                        >
                            {props.precision ? truncateString(props.precision, 63) : ""}
                        </OpenSansText>
                    </View>
                )}
            </View>
        </TouchableOpacity>
    )
}
const styles = StyleSheet.create({
    back: {
        borderRadius: 10,
        height: 150,
        width: width / 2.7,
        marginEnd: 12,
        justifyContent: "center",
        alignItems: "center",
        marginBottom: 10
    }
})
